import { CompTableColumns, defaultCompTableColumns } from '@aloft/toolkit-shared';
import { useQueryClient } from '@tanstack/react-query';

import {
  getTkv2OrderCompTableColumnsApiQuery,
  useGetTkv2OrderCompTableColumnsAPI,
  usePutTkv2OrderCompTableColumnsAPI,
} from '../../../hooks/api/toolkitComponents.ts';

type UseCompTableColumnsResult = {
  columns: CompTableColumns;
  isLoading: boolean;
  save: (columns: CompTableColumns, saveAsDefault?: boolean) => Promise<void>;
  isSaving: boolean;
};

export const useCompTableColumns = (orderID: string): UseCompTableColumnsResult => {
  const queryClient = useQueryClient();
  const queryVariables = { pathParams: { orderID } };
  const { data, isLoading } = useGetTkv2OrderCompTableColumnsAPI(queryVariables);

  const { mutateAsync, isPending: isSaving } = usePutTkv2OrderCompTableColumnsAPI();

  const save = async (columns: CompTableColumns, saveAsDefault = false) => {
    queryClient.setQueryData(
      getTkv2OrderCompTableColumnsApiQuery(queryVariables).queryKey,
      columns,
    );
    await mutateAsync({
      pathParams: { orderID },
      queryParams: saveAsDefault ? { saveAsDefault: 'true' } : undefined,
      body: columns,
    });
  };

  const columns = data as CompTableColumns | undefined;

  return {
    columns: columns?.order.length ? columns : defaultCompTableColumns,
    isLoading,
    save,
    isSaving,
  };
};
